import { UserPermissions } from "./permissionTypes";
import { canonicalRoleId, codeRole, permissionsFromRole } from "./restaurantRoles";

const permissionsFor = (roleId: string): UserPermissions => {
  const role = codeRole(canonicalRoleId(roleId));
  return permissionsFromRole(role || codeRole("cashier")!);
};

export const DEFAULT_POS_MEMBER_PERMISSIONS: UserPermissions = permissionsFor("cashier");
export const DEFAULT_POS_CASHIER_PERMISSIONS: UserPermissions = permissionsFor("cashier");
export const DEFAULT_POS_SERVER_PERMISSIONS: UserPermissions = permissionsFor("server");
export const DEFAULT_POS_MANAGER_PERMISSIONS: UserPermissions = permissionsFor("manager");
export const DEFAULT_POS_ADMIN_PERMISSIONS: UserPermissions = permissionsFor("admin");

export const getDefaultPermissionsForRole = (role: string): UserPermissions => {
  return permissionsFor(role || "cashier");
};
